import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Jumbotron, Container, Row, Col,  CardImg } from "reactstrap";
import QuestionForm from "../AboutUsPage/QuestionForm";
import "./style.css";
import CourseCard from "./CourseCards/courseCard";
import { Helmet } from "react-helmet";


class CoursePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seCourse: {
        title: "Software Engineering",
        description:
          "Experiential application design, data structures, web development and algorithms. All the tools you need to become a successful Software Engineer."
      },
      fsCourse: {
        title: "Full Stack Web Development",
        description:
          "HTML, CSS, JavaScript, React, and more. Learn these tools so you can become a successful developer."
      },
      dataCourse: {
        title: "Data Science & Analytics",
        description:
          "Machine learning algorithms, Python, data engineering. A course curated to fintech, healthcare, marketing, and more."
      },
      exCourse: {
        title: "Experience Design",
        description:
          "Design thinking, User research, customer journeys and a lot of Post-ItsTM . A course for creative thinkers who want to bring ideas to life."
          
      },
      digCourse: {
        title: "Digital Marketing",
        description:
          "Build your marketing skills and/or build your business with this Digital Marketing Intensive course."
      }
    };
  }
  render() {
    return (
      <div className="color dark-background overflow ">
           <Helmet>
          <meta charSet="utf-8" />
          <title>Lighthouse</title>
          <link rel="canonical" href="http://atlighthouse.com" />

          <meta property="og:type" content="website" />
          <meta property="og:title" content="Lighthouse"></meta>
          <meta property="og:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta property="og:url" content="https://atlighthouse.com"></meta>
          <meta name="twitter:card" content="summary_large_image"></meta>
          <meta name="twitter:site" content="@at_lighthouse"></meta>
          <meta name="twitter:title" content="Lighthouse"></meta>
          <meta name="twitter:description" content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."></meta>
          <meta name="twitter:url" content="https://atlighthouse.com"></meta>
          <meta
            name="description"
            content="Be on a high-growth tech-career with project-based experiential learning, dedicated mentoring and career coaching."
          />
  
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, shrink-to-fit=no"
          />
          <meta
            name="keywords"
            content="Coding Bootcamps, Technology Bootcamps, Tech bootcamps, Business and technology bootcamps, 
              Business bootcamps, Bootcamp, Programming, Become a Developer, Become a Software Developer, Learn Code,
              Get Hired for coding, Immersive program, Intensive program, Atlanta Coding bootcamps, Best coding bootcamps,Top coding bootcamps in Atlanta, Free coding bootcamp, Job guarantee bootcamp, Bootcamp with job guarantee,
              Steps to becoming a developer, Steps to becoming a web developer, Steps to becoming a software engineer, How to become a developer, How to become a programmer, How to become a web developer, How to become a full stack web developer, How to become a full stack developer, How to become a software developer, How to become a software engineer, How to become a data scientist, How to become a data analyst, How to become a digital marketer, How to become a UX designer, How to become an experience designer, How to become a UI designer, Coding bootcamp with job guarantee, Full time coding bootcamps, Part time coding bootcamps, Learn full stack web development, Learn web development, Learn software engineering, Learn data science, Learn data analytics, Learn digital marketing, Learn experience design, Learn ux design, Learn ui design, Full Stack Web Development Course, Full Stack Web Development Bootcamp, Full Stack Web Development Program, Full Stack Web Development Certificate, Atlanta Full Stack Development Course, Atlanta Full Stack Development Bootcamp, Atlanta Full Stack Development Program, Atlanta Full Stack Development Certificate, Data Science Course, Data Science Bootcamp, Data Science Program, Data Science Certificate, Atlanta Data Science Course, Atlanta Data Science Bootcamp, Atlanta Data Science Program, Atlanta Data Science Certificate, Software Engineering Course, Software Engineering Bootcamp, Software Engineering Program, Software Engineering Certificate, Atlanta Software Engineering Course, Atlanta Software Engineering Bootcamp, Atlanta Software Engineering Program, Atlanta Software Engineering Certificate, Digital Marketing Course, Digital Marketing Bootcamp, Digital Marketing Program, Digital Marketing Certificate, Atlanta Digital Marketing Course, Atlanta Digital Marketing Bootcamp, Atlanta Digital Marketing Program, Atlanta Digital Marketing Certificate, UX Course, UX Certificate, UX Bootcamp, UX Program, Atlanta UX Course, Atlanta UX Certificate, Atlanta UX Bootcamp, Atlanta UX Program, Competitive programming, How to get a job in programming, Bootcamps for college students, Coding bootcamps for college students, Best coding bootcamps in atlanta, Top rated coding bootcamps in atlanta, Top rated coding bootcamps, Best coding bootcamps, Rigorous coding bootcamps, Data Science bootcamps for college students, Best Data Science bootcamps in atlanta, Top rated Data Science bootcamps in atlanta, Top rated Data Science bootcamps, Best Data Science bootcamps, Can you get a job out of a coding bootcamp?, Talent Marketplace, Technology skills, Technology career, Career in software engineering, Career in data science, Career in digital marketing, Career in ux design, Career, Learn, Programming, Coding, Machine learning courses, Web development courses"
          />
          <meta name="theme-color" content="#000000" />
        </Helmet>
        <Jumbotron className="courses-jumbo" fluid>
          <Container className="mt-5">
            <Row className="pt-5 mt-5 justify-content-center justify-content-sm-start">
              <Col className="" xs={{ size: 11 }} sm={{ size: 6, offset: 1 }}>
                <h1 className="mb-3">Course Catalogue</h1>
              </Col>
            </Row>
            <Row className="justify-content-center justify-content-sm-start">
              <Col xs={{ size: 11 }} sm={{ size: 8, offset: 1 }}>
                <p className=" pb-5 mb-5 ">
                  Accelerate your career in a profession that’s high in demand
                  with our courses in Web Development, Experience Design, Data
                  Science or Digital Marketing.
                </p>
              </Col>
            </Row>
          </Container>
        </Jumbotron>

        <div>
          <Container>
            <Row className="mb-5">
              <Col>
                <h1 className="text-center course-path mb-1">
                  Full-Time Immersive
                </h1>
              </Col>
            </Row>
            <Row>
              <Col className="">
                <p className="text-center">
                  Challenge yourself and change your career with an 14 to 16
                  week immersive learning experience.
                </p>
              </Col>
            </Row>
            <Row className="justify-content-center align-items-stretch mt-5 pb-5">
          
              <CourseCard
                sm="6"
                lg="3"
                title={this.state.seCourse.title}
                description={this.state.seCourse.description}
                path={"/web-development-immersive"}
              >
                <CardImg top width="100%" src="img/full-stack-icon-v2.png" alt="Card image cap" />
              </CourseCard>

              <CourseCard
                sm="6"
                lg="3"
                title={this.state.dataCourse.title}
                description={this.state.dataCourse.description}
                path={"/data-science-immersive"}
              >
                <CardImg top width="100%" src="img/data-science-icon-v2.png" alt="Card image cap" />
              </CourseCard>
              <CourseCard
                sm="6"
                lg="3"
                title={this.state.exCourse.title}
                description={this.state.exCourse.description}
                path={"/experience-design"}
              >
                   <CardImg top width="100%" src="img/exp-design-icon-v2.png" alt="Card image cap" />
              </CourseCard>
            </Row>
        
            <Row className="mt-5 mb-5 ">
              <Col className="">
                <h1 className="text-center course-path mb-1">
                  Part-Time Intensive
                </h1>
              </Col>
            </Row>
            <Row>
              <Col className="">
                <p className="text-center">
                  Enhance your professional potential. Learn in-demand skills
                  through evening and weekend courses.
                </p>
              </Col>
            </Row>

            <Row className="justify-content-center align-items-stretch mt-5 pb-5">

            
              <CourseCard
                sm="6"
                lg="3"
                title={this.state.fsCourse.title}
                description={this.state.fsCourse.description}
                path={"/web-development-intensive"}
              >
             <CardImg top width="100%" src="img/full-stack-icon-v2.png" alt="Card image cap" />
               
              </CourseCard>
               
              <CourseCard
                sm="6"
                lg="3"
                title={this.state.dataCourse.title}
                description={this.state.dataCourse.description}
                path={"/data-science-intensive"}
              >
                   <CardImg top width="100%" src="img/data-science-icon-v2.png" alt="Card image cap" />
              </CourseCard>
             
              <CourseCard
                sm="6"
                lg="3"
                title={this.state.digCourse.title}
                description={this.state.digCourse.description}
                path={"/digital-marketing"}
              >
                   <CardImg top width="100%" src="img/digital-marketing-icon-v2.png" alt="Card image cap" />
              </CourseCard>
            </Row>
            <Row>
              <Col sm={{ size: 5, offset: 1 }}>
                <Link
                  style={{ textDecoration: "none" }}
                  to="/digital-marketing"
                ></Link>
              </Col>
              <Col sm={{ size: 5 }}>
                <Link
                  style={{ textDecoration: "none" }}
                  to="/digital-marketing"
                ></Link>
              </Col>
            </Row>
          </Container>
        </div>
        <QuestionForm
          title={'Have Questions?'}
          textTitle={'We’d love to help you out!'}
          text={'Schedule a call with one of our Student Advisors. From curriculum to payment plans - our experts are happy to help.'}
          formValue={'Browse_course_website_v1'}
        />
      </div>
    );
  }
}

export default CoursePage;
